import { Spacer, Text } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export interface AnimationControlContainerProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
}

const AnimationControlContainer: React.FC<AnimationControlContainerProps> = ({
  title,
  children,
}) => {
  return (
    <Spacer
      orientation="horizontal"
      align="center"
      justify="space-between"
      className={block('animation-control-container')}
    >
      <Text variant="p" className={block('control-label')}>
        {title}
      </Text>

      {children}
    </Spacer>
  );
};

export default AnimationControlContainer;
